(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-finder"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // サイズバーのアニメーション
  setTimeout(() => {
    const sizeBar = document.querySelector(".sp-float-bottom");
    if (sizeBar) {
      sizeBar.style.animation = "hop 0.6s ease-in-out 3";
    }
  }, 1000);

  // CSSアニメーションの定義
  const style = document.createElement("style");
  style.innerHTML = `
    @keyframes hop {
      0% { transform: translateY(0); }
      30% { transform: translateY(-10px); }
      60% { transform: translateY(0); }
      100% { transform: translateY(0); }
    }
    .sp-float-bottom {
      animation: none;
    }
  `;
  document.head.appendChild(style);

  // 全角→半角変換用関数
  function toHalfWidth(value) {
    return value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
  }
  function containsFullWidth(value) {
    return /[Ａ-Ｚａ-ｚ０-９]/.test(value);
  }

  // 初期状態で結果エリアを非表示
  $(".sizeGuide__result").hide();
  $(".footer__sizeGuide__result").hide();

  // モバイル用サイズファインダーの表示/非表示切り替え
  document.querySelector('.footer__sizeGuide__ja').addEventListener('click', function() {
    const finder = document.querySelector('.sp-size-finder-visible-wrap');
    if (finder.style.display === 'none' || finder.style.display === '') {
      finder.style.display = 'block';
      // スクロールして表示させる
      setTimeout(() => {
        finder.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }, 100);
    } else {
      finder.style.display = 'none';
    }
  });

  // 閉じるボタンの処理
  document.querySelector('.footer_finder_close').addEventListener('click', function() {
    document.querySelector('.sp-size-finder-visible-wrap').style.display = 'none';
  });

  // 現在のページURLから商品ページかどうかを判定
  var currentURL = window.location.href;
  var productMapping = "";
  if (currentURL.indexOf("isse-snowsocks-super-outlet") !== -1) {
    productMapping = "TYPE1_SUPER_OUTLET";
  } else if (currentURL.indexOf("isse-snowsocks-classic-outlet") !== -1) {
    productMapping = "TYPE1_CLASSIC_OUTLET";
  } else if (currentURL.indexOf("isse-snowsocks-super-type-2") !== -1) {
    productMapping = "SUPER_TYPE2";
  } else if (currentURL.indexOf("isse-snowsocks-super") !== -1) {
    productMapping = "TYPE1_SUPER";
  } else if (currentURL.indexOf("isse-snowsocks-classic") !== -1) {
    productMapping = "TYPE1_CLASSIC";
  } else if (currentURL.indexOf("isse-snowsocks-truck") !== -1) {
    productMapping = "TRUCK";
  } else if (currentURL.indexOf("isse-snowsocks-classic-type-2") !== -1) {
    productMapping = "CLASSIC_TYPE2";
  } else {
    productMapping = "NONE";
  }

    // サイズ→カートインリンクを返す関数
    function getShopLink(size) {
      if (productMapping === "NONE") {
        return "LINEUP";
      }
      var variant = "";
      switch(productMapping) {
        case "TYPE1_SUPER_OUTLET":
          switch(size) {
            case "54 / XS": variant = "46095829762203"; break;
            case "58 / S": variant = "46095829794971"; break;
            case "62 / M": variant = "46095829827739"; break;
            case "66 / L": variant = "46095829860507"; break;
            case "70 / XL": variant = "46095829893275"; break;
            case "74 / XXL": variant = "46095829926043"; break;
            default: variant = "";
          }
          break;
        case "TYPE1_CLASSIC_OUTLET":
          switch(size) {
            case "54 / XS": variant = "46100192395419"; break;
            case "58 / S": variant = "46100192428187"; break;
            case "62 / M": variant = "46100192460955"; break;
            case "66 / L": variant = "46100192493723"; break;
            case "70 / XL": variant = "46100192526491"; break;
            case "74 / XXL": variant = "46100192559259"; break;
            default: variant = "";
          }
          break;
        case "TYPE1_SUPER":
          switch(size) {
            case "54 / XS": variant = "40715384586395"; break;
            case "58 / S": variant = "40715384684699"; break;
            case "62 / M": variant = "40715384717467"; break;
            case "66 / L": variant = "40715384783003"; break;
            case "70 / XL": variant = "40715384881307"; break;
            case "74 / XXL": variant = "40715384946843"; break;
            default: variant = "";
          }
          break;
        case "TYPE1_CLASSIC":
          switch(size) {
            case "54 / XS": variant = "40715379671195"; break;
            case "58 / S": variant = "40715379703963"; break;
            case "62 / M": variant = "40715379736731"; break;
            case "66 / L": variant = "40715379769499"; break;
            case "70 / XL": variant = "40715379802267"; break;
            case "74 / XXL": variant = "40715379835035"; break;
            default: variant = "";
          }
          break;
        case "TRUCK":
          switch(size) {
            case "78": variant = "40715525783707"; break;
            case "80": variant = "40715525816475"; break;
            case "88": variant = "40715525849243"; break;
            case "90": variant = "40715525882011"; break;
            case "92": variant = "42945909489819"; break;
            case "94": variant = "42946015625371"; break;
            case "96": variant = "42946029355163"; break;
            case "98": variant = "42946032402587"; break;
            case "100": variant = "42946034729115"; break;
            case "102": variant = "42946038071451"; break;
            case "104": variant = "42946041774235"; break;
            case "106": variant = "42946047639707"; break;
            case "108": variant = "42946050523291"; break;
            case "110": variant = "42946052948123"; break;
            default: variant = "";
          }
          break;
        case "CLASSIC_TYPE2":
          switch(size) {
            case "54 / XS": variant = "45559210311835"; break;
            case "58 / S": variant = "45559210344603"; break;
            case "62 / M": variant = "45559210377371"; break;
            case "66 / L": variant = "45559210410139"; break;
            case "70 / XL": variant = "45559210442907"; break;
            case "74 / XXL": variant = "45559210475675"; break;
            default: variant = "";
          }
          break;
        case "SUPER_TYPE2":
        default:
          switch(size) {
            case "54 / XS": variant = "45559194222747"; break;
            case "58 / S": variant = "45559194255515"; break;
            case "62 / M": variant = "45559194288283"; break;
            case "66 / L": variant = "45559194321051"; break;
            case "70 / XL": variant = "45559194353819"; break;
            case "74 / XXL": variant = "45559194386587"; break;
            default: variant = "";
          }
      }
      if (variant === "") {
        return "#";
      } else {
        return "https://issechains.jp/cart/" + variant + ":1";
      }
    }

  // 共通：結果表示処理
  function showResult(size, linkSelector, sizeTextSelector) {
    $(sizeTextSelector).text(size);
    var shopLink = getShopLink(size);
    if (shopLink === "LINEUP") {
      $(linkSelector).text("商品一覧を見る");
      $(linkSelector).attr("href", "https://issechains.jp/collections/line-up");
    } else {
      $(linkSelector).text("カートに追加");
      $(linkSelector).attr("href", shopLink);
    }
  }

  // 「調べる」ボタン（デスクトップ）の処理
  function bindDesktopSearch() {
    $(document).off("click", "#tire_search").on("click", "#tire_search", function(e) {
      e.preventDefault();
      if (containsFullWidth($("#tire_width").val())) {
        $("#tire_width").val(toHalfWidth($("#tire_width").val()));
      }
      if (containsFullWidth($("#tire_border").val())) {
        $("#tire_border").val(toHalfWidth($("#tire_border").val()));
      }
      if (containsFullWidth($("#tire_rim").val())) {
        $("#tire_rim").val(toHalfWidth($("#tire_rim").val()));
      }
      var tire_width = parseFloat($("#tire_width").val());
      var tire_border = parseFloat($("#tire_border").val());
      var tire_rim = parseFloat($("#tire_rim").val());
      if (isNaN(tire_width) || isNaN(tire_border) || isNaN(tire_rim)) {
        alert("タイヤ幅、偏平率、インチを正しく入力してください");
        return;
      }
      var perimeter = calcPerimeter(tire_width, tire_border, tire_rim);
      var size = judgeSize(perimeter);
      showResult(size, ".sizeGuide__result__link__buylink", "#sizeResult");
      $(".sizeGuide__result").slideDown();
      gsap.to(".sizeGuide__inner", {
        duration: 2,
        scrollTo: $(".sizeGuide__result").offset().top
      });
    });
  }

  // 「調べる」ボタン（フッター）の処理
  function bindFooterSearch() {
    $(document).off("click", "#footer_tire_search").on("click", "#footer_tire_search", function(e) {
      e.preventDefault();
      console.log("Footer tire search clicked"); // デバッグ用
      if (containsFullWidth($("#footer_tire_width").val())) {
        $("#footer_tire_width").val(toHalfWidth($("#footer_tire_width").val()));
      }
      if (containsFullWidth($("#footer_tire_border").val())) {
        $("#footer_tire_border").val(toHalfWidth($("#footer_tire_border").val()));
      }
      if (containsFullWidth($("#footer_tire_rim").val())) {
        $("#footer_tire_rim").val(toHalfWidth($("#footer_tire_rim").val()));
      }
      var tire_width = parseFloat($("#footer_tire_width").val());
      var tire_border = parseFloat($("#footer_tire_border").val());
      var tire_rim = parseFloat($("#footer_tire_rim").val());
      if (isNaN(tire_width) || isNaN(tire_border) || isNaN(tire_rim)) {
        alert("タイヤ幅、偏平率、インチを正しく入力してください");
        return;
      }
      var perimeter = calcPerimeter(tire_width, tire_border, tire_rim);
      var size = judgeSize(perimeter);
      showResult(size, ".footer__sizeGuide__result__link__buylink", "#footer_sizeResult");
      $(".footer__sizeGuide__result").slideDown();
      gsap.to(window, {
        duration: 2,
        scrollTo: ($(".footer__sizeGuide__result").offset().top - 135)
      });
    });
  }

  // スペシャルサイズ選択（デスクトップ）
  $("#tire_special").off("change").on("change", function(e) {
    var size = judgeSpecialSize($(this).val());
    $("#tire_width, #tire_border, #tire_rim").val("");
    showResult(size, ".sizeGuide__result__link__buylink", "#sizeResult");
    $(".sizeGuide__result").slideDown();
  });

  // スペシャルサイズ選択（フッター）
  $("#footer_tire_special").off("change").on("change", function(e) {
    var size = judgeSpecialSize($(this).val());
    $("#footer_tire_width, #footer_tire_border, #footer_tire_rim").val("");
    showResult(size, ".footer__sizeGuide__result__link__buylink", "#footer_sizeResult");
    $(".footer__sizeGuide__result").slideDown();
    gsap.to(window, {
      duration: 2,
      scrollTo: ($(".footer__sizeGuide__result").offset().top - 135)
    });
  });

  // イベントリスナーの初期化
  bindDesktopSearch();
  bindFooterSearch();

  // 動的に要素が追加された場合に備えて、一定間隔で再バインド
  setInterval(bindFooterSearch, 1000);

  // ユーティリティ関数
  function calcPerimeter(width, border, rim) {
    var int_cm = rim * 2.54;
    var del_ancho = (width * border) / 1000;
    var diameter = (del_ancho * 2) + int_cm;
    return 3.1416 * diameter;
  }

  function judgeSize(perimeter) {
    if (perimeter >= 155 && perimeter <= 173.99) {
      return "54 / XS";
    } else if (perimeter >= 174 && perimeter <= 185.99) {
      return "58 / S";
    } else if (perimeter >= 186 && perimeter <= 199.99) {
      return "62 / M";
    } else if (perimeter >= 200 && perimeter <= 214.99) {
      return "66 / L";
    } else if (perimeter >= 215 && perimeter <= 233.99) {
      return "70 / XL";
    } else if (perimeter >= 234 && perimeter <= 255.99) {
      return "74 / XXL";
    } else if (perimeter >= 256 && perimeter <= 265.99) {
      return "78";
    } else if (perimeter >= 266 && perimeter <= 271.99) {
      return "80";
    } else if (perimeter >= 272 && perimeter <= 278.99) {
      return "88";
    } else if (perimeter >= 279 && perimeter <= 286.99) {
      return "90";
    } else if (perimeter >= 287 && perimeter <= 290.99) {
      return "92";
    } else if (perimeter >= 291 && perimeter <= 312.99) {
      return "94";
    } else if (perimeter >= 313 && perimeter <= 319.99) {
      return "96";
    } else if (perimeter >= 320 && perimeter <= 329.99) {
      return "98";
    } else if (perimeter >= 330 && perimeter <= 338.99) {
      return "100";
    } else if (perimeter >= 339 && perimeter <= 342.99) {
      return "102";
    } else if (perimeter >= 343 && perimeter <= 348.99) {
      return "104";
    } else if (perimeter >= 349 && perimeter <= 354.99) {
      return "106";
    } else if (perimeter >= 355 && perimeter <= 362.99) {
      return "108";
    } else if (perimeter >= 363 && perimeter <= 371.99) {
      return "110";
    } else {
      return "対応商品がありません。";
    }
  }


  function judgeSpecialSize(value) {
    switch(value) {
      case "7 - 15":
      case "7 - 16":
        return "74";
      case "8.25 - 20":
        return "94";
      case "8.5 - 17.5":
        return "78";
      case "8.5 - 20":
        return "94";
      case "9.0 - 19.5":
        return "80";
      case "9 - 16":
        return "90";
      case "9 - 22.5":
        return "94";
      case "9.5 - 17.5":
        return "80";
      case "10 - 20":
        return "102";
      case "10 - 22.5":
        return "96";
      case "11 - 22.5":
        return "98";
      case "11 - 24.5":
        return "104";
      case "12 - 20":
      case "12 - 22.5":
        return "106";
      case "35/12.5 - 20":
        return "90";
      case "12,5/70 - 16":
        return "80";
      case "15,5/60 - 18":
        return "94";
      default:
        return "対応商品がありません。";
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spain-size-finder-section"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  /* ---------- 共通ユーティリティ ---------- */
  const toHalf = v =>
    v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s =>
      String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
    );
  const hasFull = v => /[Ａ-Ｚａ-ｚ０-９]/.test(v);

  /* ---------- 初期非表示 ---------- */
  $(".custom-sf-result").hide();

  /* ---------- ページ種別判定 ---------- */
  const url = location.href;
  let productMapping = "NONE";
  if (url.includes("isse-snowsocks-super-outlet")) productMapping = "TYPE1_SUPER_OUTLET";
  else if (url.includes("isse-snowsocks-classic-outlet")) productMapping = "TYPE1_CLASSIC_OUTLET";
  else if (url.includes("isse-snowsocks-super-type-2")) productMapping = "SUPER_TYPE2";
  else if (url.includes("isse-snowsocks-super")) productMapping = "TYPE1_SUPER";
  else if (url.includes("isse-snowsocks-classic-type-2")) productMapping = "CLASSIC_TYPE2";
  else if (url.includes("isse-snowsocks-classic")) productMapping = "TYPE1_CLASSIC";
  else if (url.includes("isse-snowsocks-truck")) productMapping = "TRUCK";

  /* ---------- variant 取得 ---------- */
  function getShopLink(size) {
    if (productMapping === "NONE") return "LINEUP";
    const V = {
      TYPE1_SUPER_OUTLET:{
        54:"46095829762203",58:"46095829794971",62:"46095829827739",
        66:"46095829860507",70:"46095829893275",74:"46095829926043"
      },
      TYPE1_CLASSIC_OUTLET:{
        54:"46100192395419",58:"46100192428187",62:"46100192460955",
        66:"46100192493723",70:"46100192526491",74:"46100192559259"
      },
      TYPE1_SUPER:{
        54:"40715384586395",58:"40715384684699",62:"40715384717467",
        66:"40715384783003",70:"40715384881307",74:"40715384946843"
      },
      TYPE1_CLASSIC:{
        54:"40715379671195",58:"40715379703963",62:"40715379736731",
        66:"40715379769499",70:"40715379802267",74:"40715379835035"
      },
      CLASSIC_TYPE2:{
        54:"45559210311835",58:"45559210344603",62:"45559210377371",
        66:"45559210410139",70:"45559210442907",74:"45559210475675"
      },
      SUPER_TYPE2:{
        54:"45559194222747",58:"45559194255515",62:"45559194288283",
        66:"45559194321051",70:"45559194353819",74:"45559194386587"
      },
      TRUCK:{
        78:"40715525783707",80:"40715525816475",88:"40715525849243",
        90:"40715525882011",92:"42945909489819",94:"42946015625371",
        96:"42946029355163",98:"42946032402587",100:"42946034729115",
        102:"42946038071451",104:"42946041774235",106:"42946047639707",
        108:"42946050523291",110:"42946052948123"
      }
    };
    const variant = (V[productMapping] || {})[size] || "";
    return variant ? `https://issechains.jp/cart/${variant}:1` : "#";
  }

  /* ---------- 計算 & 判定 ---------- */
  function calcPerimeter(width, border, rim) {
    const rimDiameterCm = rim * 2.54;
    const sidewallHeightCm = (width * (border / 100)) / 10;
    const tireDiameterCm = rimDiameterCm + (2 * sidewallHeightCm);
    return Number((Math.PI * tireDiameterCm).toFixed(2));
  }

  function judgeSize(peri) {
    if (peri >= 155 && peri < 174) return "54 / XS";
    else if (peri >= 174 && peri < 186) return "58 / S";
    else if (peri >= 186 && peri < 200) return "62 / M";
    else if (peri >= 200 && peri < 215) return "66 / L";
    else if (peri >= 215 && peri < 234) return "70 / XL";
    else if (peri >= 234 && peri < 256) return "74 / XXL";
    else if (peri >= 256 && peri < 266) return "78";
    else if (peri >= 266 && peri < 272) return "80";
    else if (peri >= 272 && peri < 279) return "88";
    else if (peri >= 279 && peri < 287) return "90";
    else if (peri >= 287 && peri < 291) return "92";
    else if (peri >= 291 && peri < 313) return "94";
    else if (peri >= 313 && peri < 320) return "96";
    else if (peri >= 320 && peri < 330) return "98";
    else if (peri >= 330 && peri < 339) return "100";
    else if (peri >= 339 && peri < 343) return "102";
    else if (peri >= 343 && peri < 349) return "104";
    else if (peri >= 349 && peri < 355) return "106";
    else if (peri >= 355 && peri < 363) return "108";
    else if (peri >= 363 && peri < 372) return "110";
    else return "対応商品がありません。";
  }

  function judgeSpecial(val) {
    const map = {
      "7 - 15":74,"7 - 16":74,"8.25 - 20":94,"8.5 - 17.5":78,
      "8.5 - 20":94,"9.0 - 19.5":80,"9 - 16":90,"9 - 22.5":94,
      "9.5 - 17.5":80,"10 - 20":102,"10 - 22.5":96,"11 - 22.5":98,
      "11 - 24.5":104,"12 - 20":106,"12 - 22.5":106,"35/12.5 - 20":90,
      "12,5/70 - 16":80,"15,5/60 - 18":94
    };
    return map[val] || "対応商品がありません。";
  }

  /* ---------- 結果描画 ---------- */
  function render(size) {
    $(".size-main").text(size);
    $(".sizeResult").text(size);
    const link = getShopLink(size);
    const $btn = $(".custom-sf-result-link-buylink");
    if (link === "LINEUP") {
      $btn.text("商品一覧を見る").attr("href", "https://issechains.jp/collections/line-up");
    } else {
      $btn.text("カートに追加").attr("href", link);
    }
    $(".custom-sf-result").slideDown();
  }

  /* ---------- 検索ボタン ---------- */
  $(".custom-sf-btn .custom-sf-search").on("click", function (e) {
    e.preventDefault();

    // フォーム単位でスコープを絞る ------------
    const $form  = $(this).closest(".custom-sf-form");
    const $w     = $form.find(".custom-sf-tire_width");
    const $b     = $form.find(".custom-sf-tire_border");
    const $r     = $form.find(".custom-sf-tire_rim");
    // --------------------------------------

    [$w, $b, $r].forEach($el => {
      if (hasFull($el.val())) $el.val(toHalf($el.val()));
    });

    const width  = parseFloat($w.val() || $w.attr("placeholder"));
    const border = parseFloat($b.val() || $b.attr("placeholder"));
    const rim    = parseFloat($r.val() || $r.attr("placeholder"));

    if ([width, border, rim].some(isNaN)) {
      alert("タイヤ幅、偏平率、インチを正しく入力してください");
      return;
    }

    const peri = calcPerimeter(width, border, rim);
    const size = judgeSize(peri);
    render(size);
  });

  /* ---------- スペシャルサイズ ---------- */
  $(".custom-sf-tire_special").on("change", function () {
    $(".custom-sf-tire_width, .custom-sf-tire_border, .custom-sf-tire_rim").val("");
    render(judgeSpecial($(this).val()));
  });

  /* ---------- カート追加 ---------- */
  $(document).on("click", ".custom-sf-result-link-buylink", function (e) {
    const href = this.href;
    if (!href || href === "#" || href.endsWith("#")) {
      e.preventDefault();
      alert("対応する商品が見つかりませんでした。商品一覧をご覧ください。");
      return;
    }
    if (href.includes("/collections/line-up")) return; // 通常遷移

    e.preventDefault();
    fetch("/cart/add.js", {
      method: "POST",
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify({
        items: [{id: href.split("/cart/")[1].split(":")[0], quantity: 1}]
      })
    })
    .then(r => r.json())
    .then(() => location.href = "/cart")
    .catch(() => alert("カートに追加できませんでした。もう一度お試しください。"));
  });
});

  } catch(e) { console.error(e); }
})();
})();
